'use strict'

const abortMixins = {
    created() {
        this._abortors = Object.create(null)
    },
    unmounted() {
        Object.values(this._abortors).forEach(c => c?.abort())
    },
    methods: {
        abortController(name) {
            if (!this._abortors) this._abortors = {}

            const prev = this._abortors[name]
            if (prev) {
                try { prev.abort() } catch (e) {/**/}
            }
            this._abortors[name] = null
        },

        setController(name) {
            if (!this._abortors) this._abortors = {}

            this.abortController(name)
            const c = new AbortController()
            this._abortors[name] = c
            return c
        },
    }
}

export default abortMixins
